import { ModelBase } from '@framework/models/base/base.model';
import { UserContextModel } from '../../auth-models';

export class LoginOutputApiModel extends ModelBase {
    public userContext: UserContextModel;
    constructor(init?: Partial<LoginOutputApiModel>){
        super(init);
        Object.assign(this, init);
    }
}